"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Proxy = (function () {
    function Proxy(handler) {
        this.handler = {};
        this.handler = handler;
    }
    Proxy.prototype.proxy = function (target) {
        var me = this;
        var getter = this.handler.get ?
            function (prop) {
                return me.handler.get ? me.handler.get(target, prop, me) : null;
            } :
            function (prop) {
                return target[prop];
            };
        var setter = this.handler.set ?
            function (prop, value) {
                return me.handler.set ? me.handler.set(target, prop, value, me) : null;
            } : function (prop, value) {
            Object.defineProperty(me, prop, { value: value });
        };
        var propertyNames = Object.getOwnPropertyNames(target);
        var propertyMap = {};
        propertyNames.forEach(function (prop) {
            var real = Object.getOwnPropertyDescriptor(target, prop);
            var desc = {
                enumerable: real != null ? !!real.enumerable : true,
                get: getter.bind(target, prop),
                set: setter.bind(target, prop),
            };
            Object.defineProperty(me, prop, desc);
            propertyMap[prop] = true;
        });
        return this;
    };
    return Proxy;
}());
exports.default = Proxy;
//# sourceMappingURL=Proxy.js.map